import { useTranslation } from 'react-i18next';
import { Icon } from '../shared/components/Icon';
import { navigationLeaves, operationsNavigation, primaryNavigation } from './navigation';
import { describeAddress } from './panelCatalog';
import { useWorkspace, useWorkspaceActions } from './WorkspaceProvider';

/**
 * What an empty pane shows.
 *
 * It is deliberately a working surface rather than an apology: the destinations that
 * open most often, whatever was open recently, and — because the gestures are the part
 * nobody guesses — a short reading of what dragging a tab actually does.
 */
export function WorkspaceStartPage() {
  const { t } = useTranslation();
  const state = useWorkspace();
  const { open } = useWorkspaceActions();
  const suggestions = [...navigationLeaves(primaryNavigation).slice(0, 6), ...navigationLeaves(operationsNavigation).slice(0, 4)];
  const recents = state.recents.filter((address) => !Object.values(state.panels).some((panel) => panel.address === address)).slice(0, 5);

  return (
    <div className="workspace-start">
      <div className="workspace-start__intro">
        <span className="workspace-start__mark" aria-hidden="true"><Icon name="layout" /></span>
        <h2>{t('workspace.startTitle')}</h2>
        <p>{t('workspace.startSubtitle')}</p>
      </div>

      <section className="workspace-start__section" aria-labelledby="workspace-start-open">
        <h3 id="workspace-start-open">{t('workspace.quickOpen')}</h3>
        <div className="workspace-start__grid">
          {suggestions.map((item) => (
            <button key={item.to} type="button" className="workspace-start__card" onClick={() => open(item.to)}>
              <Icon name={item.icon} />
              <span>{t(item.labelKey)}</span>
            </button>
          ))}
        </div>
      </section>

      {recents.length === 0 ? null : (
        <section className="workspace-start__section" aria-labelledby="workspace-start-recent">
          <h3 id="workspace-start-recent">{t('workspace.recent')}</h3>
          <div className="workspace-start__recent">
            {recents.map((address) => {
              const identity = describeAddress(address, t);
              return (
                <button key={address} type="button" className="workspace-start__recent-item" onClick={() => open(address)}>
                  <Icon name={identity.icon} className="icon icon--small" />
                  <span>{identity.title}</span>
                  {identity.detail === null ? null : <em>{identity.detail}</em>}
                </button>
              );
            })}
          </div>
        </section>
      )}

      <ul className="workspace-start__hints">
        <li><Icon name="splitBeside" className="icon icon--small" />{t('workspace.hintDrag')}</li>
        <li><Icon name="float" className="icon icon--small" />{t('workspace.hintFloat')}</li>
        <li><Icon name="maximize" className="icon icon--small" />{t('workspace.hintKeys')}</li>
      </ul>
    </div>
  );
}
